<div *ngIf="creator" class="showcase-created-by d-flex" data-automation-id="showcase-creator">
  <span class="label" translate>customShowcaseCreatedBy</span>
  <span class="name">
    <span class="icon far fa-user ml-1" aria-hidden="true"></span>
    {{creator}}
  </span>
</div>
